import { all } from 'redux-saga/effects';
import { getAsyncSagas } from 'react-async-client';

import appRun from './appRun';

export default function* rootSaga() {
    yield all([
        ...getAsyncSagas(),
        appRun(),
    ]);
}
